class HelperModel extends App.Models.BaseModel {
    modelUrl = 'Helper';
}

App.Models.Helper = HelperModel;